import React, { useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../api/endpoints';

/**
 * Self-service preferences, visible to every employee (not admin-gated) --
 * currently just the opt-in for the once-a-day activity summary email,
 * which mirrors what the notification bell already shows in real time but
 * batches it into a single end-of-day email instead.
 */
const MyPreferencesModal = ({ employee, onClose, onUpdated }) => {
  const [receiveDailyDigest, setReceiveDailyDigest] = useState(!!employee?.receive_daily_digest);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    try {
      setSaving(true);
      const updated = await api.updateMyPreferences({ receive_daily_digest: receiveDailyDigest });
      onUpdated?.(updated);
      toast.success('Preferences saved.');
      onClose();
    } catch (error) {
      toast.error('Could not save preferences.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ margin: 0 }}>My preferences</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>

        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.9rem', cursor: 'pointer', marginBottom: '0.5rem' }}>
          <input
            type="checkbox" checked={receiveDailyDigest} disabled={saving}
            onChange={(e) => setReceiveDailyDigest(e.target.checked)}
            style={{ marginTop: '0.2rem' }}
          />
          <span>
            Email me a daily summary
            <br />
            <span style={{ fontSize: '0.78rem', color: '#aab7c4' }}>
              Once a day, get an email of what happened related to you -- the same things you'd see in the
              notification bell, batched into one message instead of arriving in real time.
            </span>
          </span>
        </label>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '1rem' }}>
          <button type="button" className="btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="button" className="btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
};

export default MyPreferencesModal;
